import { cn } from "@/app/utils/cn";

type Step = {
  label: string;
};

type StepperProps = {
  steps: Step[];
  currentStep: number;
  onClick?: (step: number) => void;
};

export function Stepper({ steps, currentStep, onClick }: StepperProps) {
  return (
    <div className="flex w-full items-start">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;
        const isLast = index === steps.length - 1;

        return (
          <div
            key={index}
            onClick={() => onClick && onClick(stepNumber)}
            className="relative flex flex-1 flex-col items-center"
          >
            {!isLast && (
              <div className="absolute left-1/2 top-4 h-0.5 w-full overflow-hidden">
                <div className="absolute inset-0 bg-zinc-300" />
                <div
                  className={cn(
                    "absolute inset-y-0 left-0 bg-primary transition-all duration-500",
                    isCompleted && "w-full",
                    isActive && "w-1/2",
                    !isCompleted && !isActive && "w-0",
                  )}
                />
              </div>
            )}

            <div
              className={cn(
                "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 bg-white text-xs font-semibold transition-all duration-300",
                isCompleted || isActive
                  ? "border-primary text-primary"
                  : "border-zinc-300 text-zinc-400",
              )}
            >
              {stepNumber}
            </div>

            <span
              className={cn(
                "mt-1.5 whitespace-nowrap text-[10px] font-semibold text-gray-600 dark:text-white sm:text-xs",
              )}
            >
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
